import { createTenantRole } from '@infuse/api/iam/tenant';
import { useGenericCreateRole } from '@infuse/iam/role/mutations';

export const useCreateTenantRole = () => {
  return useGenericCreateRole({
    apiFn: createTenantRole
  });
};
